// extracted by mini-css-extract-plugin
export default {"button":"KakaoPayButton_button__bX1Lk","icon":"KakaoPayButton_icon__ZUVQb","text":"KakaoPayButton_text__jttLp"};